class MaterialAccordionTabs extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.material-accordion');
    this.tabs = this.querySelectorAll('.material-accordion__tab');
    this.items = this.section.querySelectorAll('.material-accordion__item');

    this.init();
  }

  init() {
    if (this.tabs.length === 0) return;

    // Initialize: show only items matching the first active tab
    const activeTab = this.querySelector('.material-accordion__tab--active');
    if (activeTab) {
      this.filterItems(activeTab.dataset.tab);
    }

    // Handle tab clicks
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.handleTabClick(tab));
    });
  }

  handleTabClick(clickedTab) {
    const tabName = clickedTab.dataset.tab;

    // Update active state
    this.tabs.forEach(tab => tab.classList.remove('material-accordion__tab--active'));
    clickedTab.classList.add('material-accordion__tab--active');

    // Filter items
    this.filterItems(tabName);
  }

  filterItems(tabName) {
    this.items.forEach(item => {
      const itemTab = item.dataset.tab;

      if (itemTab === tabName) {
        item.classList.remove('material-accordion__item--hidden');
      } else {
        item.classList.add('material-accordion__item--hidden');
        // Close the item if it's open
        if (item.hasAttribute('open')) {
          item.removeAttribute('open');
        }
      }
    });
  }
}

if (!customElements.get('material-accordion-tabs')) {
  customElements.define('material-accordion-tabs', MaterialAccordionTabs);
}

class AccordionParent extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('details').forEach(details => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        const summary = details.querySelector('summary');
        if (!summary) return;
        requestAnimationFrame(() => {
          summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    });
  }
}

if (!customElements.get('accordion-parent')) {
  customElements.define('accordion-parent', AccordionParent);
}
